'use client';

import { cn } from '@/styles/utils';
import Link from 'next/link';

export function Footer({ className }: { className?: string }) {
  return (
    <footer className={cn('flex text-(--secondary-600) gap-18', className)}>
      <span className="body-16b">(주)푸디버스</span>
      <div className="flex flex-col gap-y-1">
        <p className="flex gap-x-1">
          <span className="body-14b">대표이사</span>
          <span className="body-14r">:</span>
          <span className="body-14r">강원호</span>
        </p>
        <p className="flex gap-x-1">
          <span className="body-14b">주소</span>
          <span className="body-14r">:</span>
          <span className="body-14r">
            서울특별시 강남구 역삼로 512, 1F
          </span>
        </p>
        <p className="flex gap-x-1">
          <span className="body-14b">사업자 등록번호</span>
          <span className="body-14r">:</span>
          <span className="body-14r">206-86-64153</span>
          <button
            type="button"
            onClick={() =>
              window.open(
                'https://www.ftc.go.kr/bizCommPop.do?wrkr_no=2068664153',
                '_blank',
              )
            }
            className="body-14r underline pl-1"
          >
            사업자 정보 확인 {'>'}
          </button>
        </p>
        <p className="flex gap-x-1">
          <span className="body-14b">통신판매업신고</span>
          <span className="body-14r">:</span>
          <span className="body-14r">2024-서울강남-06009 호</span>
        </p>
        <p className="flex gap-x-1">
          <span className="body-14b">E-mail</span>
          <span className="body-14r">:</span>
          <span className="body-14r">easymeat@easymeat.ai</span>
        </p>
      </div>
      <div>
        <p className="body-14b">고객센터</p>
        <p className="title-24b">070-4225-3101</p>
        <p className="body-14r">평일 09:00 ~ 18:00 (점심시간 11:30 ~ 12:30)</p>
      </div>
      <div className="flex flex-col gap-2 ml-auto items-end">
        <div className="flex body-14r gap-8 flex-1">
          <Link href="#" target="_blank">
            회사소개
          </Link>
          <Link href="/terms">이용약관</Link>
          <Link href="/privacy">개인정보처리방침</Link>
        </div>
        <span className="body-12r text-(--secondary-400)">
          Copyright © 2025 Foodiverse Co., Ltd. All rights reserved
        </span>
      </div>
    </footer>
  );
}
